import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import INTERESTS from 'constant/interests';
import ACTIVITIES from 'constant/activities';
import SchoolInfoForm from 'modules/student/profile/profileForms/HighSchool';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Box from '@material-ui/core/Box';
import Button from 'components/common/Button';
import IconButton from '@material-ui/core/IconButton';
import LaunchIcon from '@material-ui/icons/Launch';
import { makeStyles } from '@material-ui/core/styles';
import Field from './Field';

const useStyles = makeStyles({
  root: {
    textAlign: 'center',
  },
});


const Screenshot = ({ onClose, url }) => {
  const classes = useStyles();

  return (
    <Dialog open fullWidth maxWidth="md">
      <DialogContent
        classes={{
          root: classes.root,
        }}
      >
        <img src={url} alt="result-screenshot"/>
        <Box
          textAlign="right"
          paddingTop={3}
          paddingBottom={3}
          onClick={onClose}
        >
          <Button variant="contained" color="primary">
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

const SchoolInfo = ({ editable, student, profile: { highschool_info } }) => {
  const [showDetails, toggleDetails] = useState(false);
   return <SchoolInfoForm user={student} editable={editable} />;
  return (
    <Card>
      <CardContent>
        <Typography gutterBottom variant="subtitle1">
          High School Info
        </Typography>
        <Grid container spacing={2}>
          <Grid item md={4}>
            <Field
              label="High School Name"
              value={highschool_info.highschool_name}
            />
          </Grid>
          <Grid item md={4}>
            <Field
              label="High School City"
              value={highschool_info.highschool_city}
            />
          </Grid>
          <Grid item md={4}>
            <Field
              label="High School State"
              value={highschool_info.highschool_state}
            />
          </Grid>
          <Grid item md={4}>
            <Field
              label="High School Type"
              value={highschool_info.highschool_type}
            />
          </Grid>
          <Grid item md={4}>
            <Field
              label="Graduation Year"
              value={highschool_info.graduation_year}
            />
          </Grid>
        </Grid>
        <br />
        <Typography gutterBottom variant="subtitle1">
          Academic Info
        </Typography>
        <Field
          label="Weighted GPA"
          value={highschool_info.current_gpa_weighted}
        />
        <Field
          label="Unweighted GPA"
          value={highschool_info.current_gpa_unweighted}
        />
        <Field label="PSAT Scores" value={highschool_info.psat_score} />
        <br/>
        <Typography variant="subtitle1">
          SAT Score
        </Typography>
        { highschool_info.sat_scores?.map((i, idx) => (
          <Grid container spacing={1} key={idx}>
            <Grid item md={2}>
              <Field label="Date" value={i.date} />
            </Grid>
            <Grid item md={2}>
              <Field label="Overall" value={i.overall} />
            </Grid>
            <Grid item md={2}>
              <Field label="Math" value={i.math} />
            </Grid>
          </Grid>
        ))}
        <br/>
        <Typography variant="subtitle1" gutterBottom>
          SAT Subject Tests
        </Typography>
        {highschool_info.sat_subject_scores?.map((i) => (
          <Grid container spacing={1}>
            <Grid item md={2}>
              <Typography variant="subtitle2">{i.subject}</Typography>
            </Grid>
            <Grid item md={2}>
              <Typography>{i.score}</Typography>
            </Grid>
          </Grid>
        ))}
        <br/>
        <Typography variant="subtitle1" gutterBottom>
          ACT Score
        </Typography>
        { highschool_info.act_scores?.map((i, idx) => (
          <Grid container spacing={1} key={idx}>
            <Grid item md={2}>
              <Field label="Date" value={i.date} />
            </Grid>
            <Grid item md={2}>
              <Field label="Overall" value={i.overall} />
            </Grid>
            <Grid item md={2}>
              <Field label="Math" value={i.math} />
            </Grid>
            <Grid item md={2}>
              <Field label="English" value={i.english} />
            </Grid>
            <Grid item md={2}>
              <Field label="Reading" value={i.reading} />
            </Grid>
            <Grid item md={2}>
              <Field label="Science" value={i.science} />
            </Grid>
          </Grid>
        ))}
        <br/>
        <Typography gutterBottom variant="subtitle1">
          Results Screenshot
        </Typography>
        {highschool_info.results_image_url ? (
          <Box display="flex">
            <Typography color="textPrimary" variant="body2">
              View Screenshot
            </Typography>{' '}
            <IconButton
              size="small"
              style={{ marginRight: 'auto', paddingTop: 0 }}
              onClick={() => toggleDetails(true)}
            >
              <LaunchIcon fontSize="small" color="disabled" />
            </IconButton>
          </Box>
        ) : (
          'N/A'
        )}
        <br />
        <Typography gutterBottom variant="subtitle1">
          Other
        </Typography>
        <Field
          label="Academic Interests"
          value={highschool_info.academic_interests
            ?.map((i) => INTERESTS.find((e) => e.value === i).label)
            .join(', ')}
          description={highschool_info.academic_interests_description}
        />
        <Field
          label="Extracurricular Activities"
          value={highschool_info.extra_activities
            ?.map((i) => ACTIVITIES.find((e) => e.value === i).label)
            .join(', ')}
          description={highschool_info.extra_activities_description}
        />
      </CardContent>
      {showDetails && (
        <Screenshot
          url={highschool_info.results_image_url}
          onClose={() => toggleDetails(false)}
        />
      )}
    </Card>
  );
};

export default SchoolInfo;
